import DOMPurify from "dompurify";
import { marked } from "marked";

// Respostas do assistente chegam em Markdown (títulos, negrito, listas, tabelas).
// `breaks: true` respeita quebras de linha simples; `gfm: true` habilita tabelas/listas do GitHub.
marked.setOptions({ gfm: true, breaks: true });

// Converte o Markdown do assistente em HTML já sanitizado.
// O marked v4 não sanitiza e repassa HTML cru, então passamos pelo DOMPurify
// como defense-in-depth caso a resposta reflita conteúdo controlado pelo usuário.
export function renderizarMarkdownSeguro(markdown: string): string {
	const html = marked.parse(markdown ?? "", { async: false }) as string;
	return DOMPurify.sanitize(html);
}
